import React, { useEffect } from "react";
import { Box, Grow, IconButton, Paper, Popper, TextField } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";

import { Row } from "../../Layout/utils";

export const NameInputMenu = ({
  anchorEl,
  error,
  onClose,
  onSubmit,
  open,
  value,
}: {
  anchorEl: any;
  error?: Error | null;
  // Icon: ReactNode;
  // onChange: (name: string) => void;
  onClose: () => void;
  onSubmit: (name: string) => void;
  open: boolean;
  value: string;
}) => {
  const [newName, setNewName] = React.useState(value);

  useEffect(() => {
    setNewName(value);
  }, [value]);

  return (
    <Popper open={open} anchorEl={anchorEl} transition style={{ zIndex: 1 }}>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" ? "center top" : "center bottom",
          }}
        >
          <Paper sx={{ py: 0.5, px: 2 }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit(newName);
              }}
            >
              <Row
                sx={{
                  alignItems: "center",
                  gap: 1,
                  height: "48px",
                  px: 0.5,
                }}
              >
                <TextField
                  variant="standard"
                  error={!!error}
                  helperText={error?.message}
                  autoFocus={true}
                  value={newName}
                  id="margin-dense"
                  fullWidth
                  onChange={(event) => setNewName(event.target.value)}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <Box sx={{ ml: 0.5, pt: 0.375, pb: 0.75 }}>
                          <IconButton
                            onClick={() => setNewName("")}
                            size="large"
                          >
                            <CancelRoundedIcon
                              sx={{ fontSize: "16px", color: "text.secondary" }}
                            />
                          </IconButton>
                        </Box>
                      ),
                    },
                  }}
                />
                <Row>
                  <IconButton color="primary" size="small" type="submit">
                    <CheckIcon />
                  </IconButton>
                  <IconButton onClick={onClose} size="small">
                    <ClearIcon />
                  </IconButton>
                </Row>
              </Row>
            </form>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
